<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">ダッシュボード</h2>
        <v-row>
          <v-col lg="6"> </v-col>
          <v-col lg="6">
            <h3 class="subtitle-1 mb-4">お知らせ</h3>
            <v-divider />
            <v-spacer />
            <div v-if="imformations.length !== 0">
              <v-row
                v-for="imformation in imformations"
                :key="imformation.id"
                class="py-2"
              >
                <v-col md="3">
                  <span class="caption">{{
                      imformation.updatedAt | moment
                    }}</span>
                </v-col>
                <v-col md="9">
                  <a class="subtitle-2" target="_blank">
                    {{ imformation.title }}
                  </a>
                </v-col>
              </v-row>
              <v-divider class="ml-1" style="width: 95%" />
            </div>
            <div v-else>
              <p class="caption py-3 pl-2 font-weight-light">
                現在、お知らせはありません
              </p>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    }
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'ダッシュボード',
      imformations: [],
      publishedPostCount: 0
    }
  },
  mounted: function () {},
  methods: {}
}
</script>

<style scoped></style>
